// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"on_a bhh_qr bhh_a bhh_w","FaqAskQuestion__outdated":"on_b bhh_vp bhh_xe"};